import React, { useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { FaEye, FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";

// Sample data
const collegeData = [
    {
        id: 1,
        name: "MIT College",
        email: "info@mit.edu",
        address: "Kothrud, Pune",
        contact: "9876543210",
    },
    {
        id: 2,
        name: "COEP Tech",
        email: "admin@coep.ac.in",
        address: "Shivaji Nagar, Pune",
        contact: "9123456780",
    },
];

const College_List = () => {
    const [searchTerm, setSearchTerm] = useState("");

    const filteredColleges = collegeData.filter(
        (college) =>
            college.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            college.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <AdminAppBody
            content={
                <div className="container">
                    {/* Header Row */}
                    <div className="row align-items-center mb-3">
                        <div className="col-md-6">
                            <PageHeading
                                title="College List"
                                subTitle="Manage all registered colleges and details."
                            />
                        </div>
                       
                    </div>

                    {/* Search Bar */}
                    <div className="mb-4">
                        <div className="input-group">
                            <span className="input-group-text bg-white border-end-0">
                                <FaSearch />
                            </span>
                            <input
                                type="text"
                                className="form-control border-start-0"
                                placeholder="Search by name or email"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div className="card shadow-sm">
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="bg-light text-uppercase small text-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>College Name</th>
                                            <th>Email</th>
                                            <th>Address</th>
                                            <th>Contact</th>
                                            <th className="text-center">
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredColleges.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan="6"
                                                    className="text-center py-4"
                                                >
                                                    No colleges found.
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredColleges.map(
                                                (college, index) => (
                                                    <tr key={college.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{college.name}</td>
                                                        <td>{college.email}</td>
                                                        <td>
                                                            {college.address}
                                                        </td>
                                                        <td>
                                                            {college.contact}
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="d-flex justify-content-center gap-2">
                                                            <Link to="/student-list">  <button
                                                                    className="sys-list-table__action view"
                                                                    title="View User"
                                                                >
                                                                    <FaEye />
                                                                </button></Link>  
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

export default College_List;
